import { useCallback, useMemo } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { ScanSearch, IdCard } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn, RowAction } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import type { AdminAppeal } from '@/lib/adapters'
import { fetchWrongfulBans, BAN_STR as S } from './strikesApi'

/**
 * A8.14 — Noto'g'ri ban tahlili. JONLI `/admin/appeals` ustidan bekor qilingan
 * (granted) ban-apellyatsiyalari — moderatsiya sifati signali. Har qator →
 * apellyatsiya kartasi (/appeals/:id).
 */
export function WrongfulBanAnalysisScreen() {
  const navigate = useNavigate()

  const columns = useMemo<AdminColumn<AdminAppeal>[]>(
    () => [
      { key: 'id', header: 'ID', type: 'id', width: 70 },
      { key: 'created_at', header: S.created, type: 'date', width: 150 },
      {
        key: 'user_id',
        header: S.userId,
        type: 'text',
        width: 160,
        sortable: false,
        render: (r) => (
          <Link to={`/users/${r.user_id}`} className="text-accent hover:underline">
            {r.username ? `@${r.username}` : `#${r.user_id}`}
          </Link>
        ),
      },
      { key: 'reason', header: S.reason, type: 'longtext', minWidth: 220 },
      { key: 'decision_note', header: S.decisionNote, type: 'longtext', minWidth: 200 },
    ],
    [],
  )

  const rowActions = useMemo<RowAction<AdminAppeal>[]>(
    () => [
      {
        id: 'open',
        label: S.open,
        icon: <IdCard size={13} />,
        onSelect: (r) => navigate(`/appeals/${r.id}`),
      },
    ],
    [navigate],
  )

  const fetcher = useCallback(fetchWrongfulBans, [])
  return (
    <>
      <PageHeader title={S.wrongful} screenId="A8.14" description={S.wrongfulNote} />
      <DataTable<AdminAppeal>
        screenId="A8.14"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        rowActions={rowActions}
        exportable
        emptyState={{ icon: <ScanSearch size={28} strokeWidth={1.5} />, title: S.wrongful }}
      />
    </>
  )
}
